import { Reveal } from "./Reveal";
import { IMAGES } from "@/data/menu";

const CHAPTERS = [
  {
    n: "01",
    title: "House of Flavours",
    body: "In Kannada, Paakamane means the House of Flavours — and that is exactly how we cook for you: unhurried, honest, and full of care.",
  },
  {
    n: "02",
    title: "Rooted in Udupi",
    body: "Our recipes travel from the temple town of Udupi — light and purely vegetarian. Batters are ground fresh, sambar simmers slow, and chutney is prepared the way it should be.",
  },
  {
    n: "03",
    title: "From dawn till night",
    body: "Idli and dosé from early morning, a South Indian meal by noon, and sizzling Indo-Chinese from half past two — with filter coffee brewing all day long.",
  },
];

export function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Tall arch image */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <div className="overflow-hidden rounded-t-[999px] rounded-b-2xl border border-line">
                <img
                  src={IMAGES.cooking}
                  alt="Fresh vegetables being prepared in the kitchen"
                  className="w-full h-[520px] md:h-[640px] object-cover"
                />
              </div>
            </Reveal>
          </div>

          {/* Manifesto */}
          <div className="lg:col-span-7 lg:pl-6">
            <Reveal>
              <span className="font-body text-xs uppercase tracking-[0.35em] text-terracotta">
                Our Story
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.02] mt-6 mb-14">
                A small cafe cooking the way{" "}
                <span className="italic text-olive">home once did.</span>
              </h2>
            </Reveal>

            <div className="space-y-12">
              {CHAPTERS.map((c, i) => (
                <Reveal key={c.n} delay={i * 0.08}>
                  <div className="flex gap-6 md:gap-8 border-t border-line pt-8">
                    <span className="font-display text-3xl md:text-4xl text-terracotta/70 shrink-0 leading-none">
                      {c.n}
                    </span>
                    <div>
                      <h3 className="font-display text-2xl md:text-3xl text-ink mb-2">
                        {c.title}
                      </h3>
                      <p className="font-body text-ink/65 leading-relaxed max-w-xl">
                        {c.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
